"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../../_helpers/constants");

var _Img = _interopRequireDefault(require("../../../elements/Img"));

var _icons = require("../../../icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const ProfileImg = (0, _styledComponents.default)(_Img.default).withConfig({
  displayName: "ProfileImg"
})(["width:", ";height:", ";border-radius:", ";"], props => props.width, props => props.height, props => props.borderRadius);

class ProfileThumb extends _react.default.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "thumbImgRef", _react.default.createRef());

    _defineProperty(this, "_handleOnError", () => {
      this.thumbImgRef.current.src = _icons.profileThumb;
    });

    _defineProperty(this, "_determineSrc", () => {
      const _this$props = this.props,
            icon = _this$props.icon,
            shiftName = _this$props.shiftName,
            thumbUrl = _this$props.thumbUrl;

      if (shiftName) {
        switch (shiftName) {
          case _constants.shiftNames.SHIFT:
          case _constants.shiftNames.SHIFT_INVENTORY:
            return thumbUrl;

          case _constants.shiftNames.SHIFT_VTO:
            return _icons.vtoAvatar;

          case _constants.shiftNames.OPEN_SHIFT:
            return _icons.shiffyAvatar;

          default:
            break;
        }
      } else if (icon) {
        switch (icon) {
          case 'shiffy':
            return _icons.shiffyAvatar;

          case 'vto':
            return _icons.vtoAvatar;

          default:
            return _icons.profileThumb;
        }
      }

      return thumbUrl || _icons.profileThumb;
    });
  }

  render() {
    const _this$props2 = this.props,
          width = _this$props2.width,
          height = _this$props2.height,
          borderRadius = _this$props2.borderRadius,
          className = _this$props2.className;
    return /*#__PURE__*/_react.default.createElement(ProfileImg, {
      src: this._determineSrc(),
      alt: "User Thumb",
      onError: this._handleOnError,
      ref: this.thumbImgRef,
      width: width,
      height: height,
      borderRadius: borderRadius,
      className: className
    });
  }

}

ProfileThumb.propTypes = {
  thumbUrl: _propTypes.default.string,
  icon: _propTypes.default.oneOf(['shiffy', 'vto']),
  shiftName: _propTypes.default.oneOf(Object.values(_constants.shiftNames)),
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  borderRadius: _propTypes.default.string,
  className: _propTypes.default.string
};
ProfileThumb.defaultProps = {
  thumbUrl: null,
  icon: null,
  shiftName: null,
  width: '100%',
  height: 'auto',
  borderRadius: '100%',
  className: ''
};
var _default = ProfileThumb;
exports.default = _default;